import { render } from "./ReportMassage.vue?vue&type=template&id=1fdfe655"
import script from "./ReportMassage.vue?vue&type=script&lang=js"
export * from "./ReportMassage.vue?vue&type=script&lang=js"

import "./ReportMassage.vue?vue&type=style&index=0&id=1fdfe655&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__